import {disableInlineConsole, enableInlineConsole, isInlineConsoleEnabled} from "../modules/inline-console";
import {SecondaryActionMenuButton} from "@soap/baseweb";

export function EnableILC({}) {

    const toggleIlc = () => {
        if (isInlineConsoleEnabled()) {
            disableInlineConsole();
        } else {
            enableInlineConsole();
        }
    };

    return (
        <>
            <div>
                <SecondaryActionMenuButton onClick={toggleIlc}>Toggle ILC</SecondaryActionMenuButton>
                <SecondaryActionMenuButton onClick={() => { window.location.href = `${window.location.origin}/`; }}>Home</SecondaryActionMenuButton>
            </div>
        </>);
}